import { useState } from "react";
import { useEffect } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import EpimsLogoOnly from "./components/EpimsLogoOnly";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'


const MainWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  padding: 10px;
  margin-inline: auto;
`

const ListWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

const ListEntry = styled.div`
  width: min(700px, 100%);
  border: 2px solid black;
  border-radius: 25px;
  display: grid;
  grid-template-columns: 60px auto;
  margin-block: 15px;
`

const ListContent = styled.div`
  display: grid;
  grid-template-columns: 160px auto;
  @media (width <= 600px) {
    grid-template-columns: 100%;
    margin-inline: 20px;
  }
`

const LogoBox = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
`

const LogoImage = styled.img`
  width: 90%;
  height: 90%;
  max-width: 120px;
  max-height: 100px;
  object-fit: contain;
  @media (width <= 600px) {
    margin-top: 20px;
  }
`

const Details = styled.div`
  margin-block: 5px;
  margin-inline: 5px;
  p {
    margin: 0px;
    font-size: 16px;
    font-weight: normal;
  }
  p.name {
    font-weight: bold
  }       
`

const RequestButton = styled.button`
  width: min(100%, 600px);
  height: 60px;
`

function ContractorListingPage({reportMode}) {

    const routeParams = useParams()
    const [loaded, setLoaded] = useState(false)
    const [contractorList, setContractorList] = useState([])
    const [selectedContractors, setSelectedContractors] = useState([])
    const [measureName, setMeasureName] = useState('')
    const [address, setAddress] = useState('')

    const [showFormModal, setShowFormModal] = useState(false)
    const [requestInProgress, setRequestInProgress] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [modalText, setModalText] = useState('')
    const [modalCloseReshowForm, setModalCloseReshowForm] = useState(false)

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [newsletter, setNewsletter] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        const url = process.env.REACT_APP_API_END_POINT + 'contractors';
        fetch(url, {
          headers: {
            'Accept': 'application/json',
          },
          method: "POST",
          credentials: "include",
          body: JSON.stringify({
            "report_path": routeParams.id + '/' + routeParams.slug,
            "measure_code": routeParams.measureCode,
            "report_mode": reportMode
          })
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['success'] === true) {
           setLoaded(true)
           setMeasureName(data['measure_name'])
           setAddress(data['short_title'])
           setContractorList(data['contractors'])
           var keys = []
           data['contractors'].forEach(c => {
            keys.push(c.key)
           })
           setSelectedContractors(keys)
          }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const clickRequest = () => {
      if (selectedContractors.length === 0) {
        setModalTitle('Error')
        setModalText("No contractors selected")
        setShowModal(true)
      } else {
        setShowFormModal(true)
      }
    }

    const submitRequest = () => {
      setRequestInProgress(true)
      const url = process.env.REACT_APP_API_END_POINT + 'contractorsrequest';
        fetch(url, {
          headers: {
            'Accept': 'application/json',
          },
          method: "POST",
          credentials: "include",
          body: JSON.stringify({
            "report_path": routeParams.id + '/' + routeParams.slug,
            "measure_code": routeParams.measureCode,
            "selected_contractors": selectedContractors,
            phone, name, email, newsletter,
            "report_mode": reportMode
          })
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['success'] === true) {
            setRequestInProgress(false)
            setShowFormModal(false)
            setModalTitle('Thank you')
            setModalText("Thank you, we will be back in touch once we hear from your selected contractors.")
            setShowModal(true)
          } else {
            if ((data['message'] ?? '') !== '') {
              setRequestInProgress(false)
              setModalTitle('Error')
              setModalText(data['message'])
              setShowFormModal(false)
              setModalCloseReshowForm(true)
              setShowModal(true)
              
            }
          }
        });
    }

    const getButton = () => {
      return <RequestButton className="btn btn-lg btn-primary" onClick={clickRequest}>Request Quotes</RequestButton>
    }

    const toggleContractor = (e, contractor) => {
      if (selectedContractors.includes(contractor.key)) {
        // remove the contractor
        const clone = selectedContractors.filter(i => i !== contractor.key)
        setSelectedContractors(clone)
      } else {
        // add the contractor
        const clone = [...selectedContractors]
        clone.push(contractor.key)
        setSelectedContractors(clone)
      }
    }

    const hideModal = () => {
      setShowModal(false)
      if (modalCloseReshowForm) {
        setModalCloseReshowForm(false)
        setShowFormModal(true)
      }
    }

    const backToMeasuresList = () => {
      // this is only for preliminary reports
      navigate('/s/' + routeParams.id + '/' + routeParams.slug + '/c')
    }

    if (!loaded) return <div><FontAwesomeIcon className="spinner-slow" icon={solid("spinner")} style={{color: "#000000", height: "100px", width: "100px" }} /></div>

    return (
      <>
        <MainWrapper>
            <p style={{textAlign: "center"}}><EpimsLogoOnly /></p>
            <h1 style={{textAlign: "center"}}>Recommended contractors for {measureName} at {address}</h1>
            <p>epIMS recommends the following contractors that cover your area. Please select the contractors you would like to request a quote from and click 'Request Quotes'. We will automatically provide them with the information they need from your EPC Survey and your report to enable them to quote for the work required.</p>            
            {reportMode === 'preliminary' && <>
              <button onClick={backToMeasuresList} style={{background: "none", border: 0, padding: 0, margin: "0 0 16px 0", color: "#2563eb", font: "inherit", textDecoration: "underline", cursor: "pointer"}}>Back to measures list</button>
            </>}
            <ListWrapper>
              {contractorList.map((contractor) => {
                return (
                  <ListEntry key={contractor.key}>
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                      <input style={{transform: "scale(4)"}} type="checkbox" checked={selectedContractors.includes(contractor.key)} onChange={(e) => toggleContractor(e, contractor)} />
                    </div>
                    <ListContent>
                      <LogoBox>
                        <LogoImage alt="" src={"data:" + contractor.image_mime + ";base64," + contractor.image } />
                      </LogoBox>
                      <Details>
                        <p><strong><a href={ contractor.url }>{ contractor.name }</a> *</strong></p>
                        <p><strong>Address:</strong> { contractor.address }</p>
                        <p><strong>Email:</strong> <a href={"mailto:" + contractor.email }>{ contractor.email }</a></p>
                        <p><strong>Phone:</strong> { contractor.tel }</p>
                      </Details>
                    </ListContent>
                  </ListEntry>
                )
              })}
              {getButton()}
              <p style={{marginTop: "10px"}}><strong>*</strong> Please refer to <a href={"https://" + process.env.REACT_APP_WWW_BASE_DOMAIN + "/terms/EPA%20Terms.pdf"} target="_blank" rel="noreferrer">Terms and Conditions</a></p>
            </ListWrapper>            
        </MainWrapper>
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)} backdrop="static">
          <Modal.Header closeButton>
              <Modal.Title>Details required</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <p>Please provide the following contact details so that we can get in touch when we hear back from your selected contractors:</p>
              <p>
                <strong>Your name: (optional)</strong><br />
                <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} />
              </p>
              <p>
                <strong>Email address: (required)</strong><br />
                <input type="email" className="form-control" value={email} onChange={e => setEmail(e.target.value)} />
              </p>
              <div style={{display: "grid", gridTemplateColumns: "auto auto", justifyContent: "center", columnGap: "12px"}}>
                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                  <input style={{width: "24px", height: "24px"}} id="newsletterSignup" type="checkbox" checked={newsletter} onChange={e => setNewsletter(e.target.checked)} />
                </div>
                <div>
                  <label htmlFor="newsletterSignup">Sign up to epIMS newsletter for energy saving tips and advice.</label>
                </div>
              </div>
              <p>
                <strong>Phone number: (optional)</strong><br />
                <input type="text" className="form-control" value={phone} onChange={e => setPhone(e.target.value)} />
              </p>
          </Modal.Body>
          <Modal.Footer>
              <Button variant="primary" onClick={submitRequest} disabled={requestInProgress}>
                  {!requestInProgress ? "Submit" : <><FontAwesomeIcon className="spinner-slow" icon={solid("spinner")} style={{color: "#FFFFFF", height: "20px", width: "20px" }} /> Submit</> }
              </Button>
              <Button variant="danger" onClick={() => setShowFormModal(false)} disabled={requestInProgress}>
                  Cancel
              </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showModal} onHide={hideModal} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{modalText}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={hideModal}>
                OK
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
}

export default ContractorListingPage;